import { useState } from "react"
import AllTab from './All/All'
import AlreadyInCampaign from "./AlreadyInCampaign/AlreadyInCampaign"
import NotInAnyCampaign from "./NotInAnyCampaign/NotInAnyCampaign"

const NewProducts = () => {

  const tabs = ['All', 'Already in Campaign', 'Not in any Campaign']
  const [activeTab, setActiveTab] = useState(tabs[0])

  return (
    <section>
      <div className="d-flex mb-3 gap-3">
        {tabs.map((tab) => (
          <div
            className="fw-medium"
            style={{
              color: tab === activeTab ? "#EC7426" : 'black',
              cursor: "pointer",
              transition: "color 1s ease",
              fontSize: "1rem",
              padding: '.5rem 0rem'
            }}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>

      {activeTab === "All" && <AllTab />}
      {activeTab === "Already in Campaign" && <AlreadyInCampaign />}
      {activeTab === "Not in any Campaign" && <NotInAnyCampaign />}
    </section>
  )
}

export default NewProducts